import React, { useState } from "react";
import axios from "axios";


const useCourseRecordController = ({
    onFinish = ({ axiosMode, status, values }) => { }, //
    onBefore = ({ axiosMode, status }) => { }, //
}) => {
    const mainApi = `/cramSchool/api/course_record`
    const [data, setData] = useState([])

    const getCourseRecordData = ({
        cur_page,
        size,
        custom_filter_value,
        custom_filter_key,
        grade_class_id,
        bill_payment_grade_class_id,
        date_start,
        date_end,
        only_date

    }) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: {
                cur_page,
                size,
                custom_filter_value,
                custom_filter_key,
                grade_class_id,
                date_start,
                date_end,
                only_date,
                bill_payment_grade_class_id,
            },
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            values: data
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error",
                            values: {
                                data: [],
                                total: 0
                            }
                        }
                    )
                }
                return {
                    ...data
                }
            });
    }
    const postCourseRecordData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )

                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })
    }
    const patchCourseRecordData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )

                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteCourseRecordData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )

                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }

            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    const getCourseRecordExcel = ()=>{
        axios
        .get('/cramSchool/api/course_record_excel', {
            responseType: 'blob',
        })
        .then((response) => {
            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', '課程紀錄範例.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        })
    }
    const postCourseRecordExcel =(data)=>{
        onBefore({
            axiosMode: "postCourseRecordExcel"
        })
        axios.post(`/cramSchool/api/course_record_excel`,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "postCourseRecordExcel",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "postCourseRecordExcel",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "postCourseRecordExcel",
                        status: "error"
                    }
                )
            })
    }
    return {
        courseRecordDatas: data,
        getCourseRecordData,
        postCourseRecordData,
        patchCourseRecordData,
        deleteCourseRecordData,
        getCourseRecordExcel,
        postCourseRecordExcel
    }
}
export { useCourseRecordController }
